import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { kfetch } from "@/components/kunden/AppointmentCard";
import { DateField } from "@/components/admin/calendar/DateField";

const inp = "w-full h-11 px-3 bg-[#0A0A0A] border border-white/20 text-white";

export default function WaitlistForm({ trainingType, email, name, date, full }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!f) return (
    <button type="button" onClick={() => setF({ date: date || "", email: email || "", name: name || "" })} className={`text-sm underline flex items-center gap-1.5 ${full ? "text-yellow-300" : "text-[#c1ff72]"}`} data-testid="waitlist-open">
      <BellRing className="w-4 h-4" />{full ? "Dieser Tag ist ausgebucht – auf die Warteliste setzen" : "Wunschtag ausgebucht? Auf die Warteliste"}</button>);
  const send = async () => {
    setBusy(true);
    try { toast.success((await kfetch("/waitlist", { method: "POST", body: JSON.stringify({ ...f, training_type: trainingType || "einzeltraining_kind" }) })).message); setF(null); } catch (e) { toast.error(e.message); }
    setBusy(false);
  };
  return (
    <div className="border border-white/15 p-4 space-y-2" data-testid="waitlist-form">
      <p className="text-sm text-white">Warteliste: Wird an deinem Wunschtag durch eine Absage ein Termin frei, bekommst du sofort eine E-Mail.</p>
      <DateField value={f.date} onChange={(v) => setF({ ...f, date: v })} testId="waitlist-date" className="h-11 rounded-none" />
      <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name" className={inp} data-testid="waitlist-name" />
      <input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="E-Mail" className={inp} data-testid="waitlist-email" />
      <button type="button" disabled={busy || !f.date || !f.email || f.name.length < 2} onClick={send} className="h-11 px-5 bg-[#c1ff72] text-black font-bold disabled:opacity-40" data-testid="waitlist-submit">Auf die Warteliste</button>
    </div>
  );
}
